import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=0dc00af5&scoped=true"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"
import style0 from "./AuthHeader.vue?vue&type=style&index=0&id=0dc00af5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc00af5",
  null
  
)

export default component.exports